import { render, staticRenderFns } from "./Autorizacion.vue?vue&type=template&id=61306e8b"
import script from "./Autorizacion.vue?vue&type=script&lang=js"
export * from "./Autorizacion.vue?vue&type=script&lang=js"
import style0 from "./Autorizacion.vue?vue&type=style&index=0&id=61306e8b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports